import React, { useState, useEffect } from "react";
import { toast } from "sonner";
import { Loader2, Send, CheckCircle2 } from "lucide-react";
import { api } from "@/lib/api";

const SAMPLE_XML = `<?xml version="1.0" encoding="UTF-8"?>
<p:FatturaElettronica xmlns:p="http://ivaservizi.agenziaentrate.gov.it/docs/xsd/fatture/v1.2" versione="FPR12">
  <FatturaElettronicaHeader>
    <!-- ... -->
  </FatturaElettronicaHeader>
  <FatturaElettronicaBody>
    <!-- ... -->
  </FatturaElettronicaBody>
</p:FatturaElettronica>`;

export default function SdiPlayground() {
  const [xml, setXml] = useState(SAMPLE_XML);
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [config, setConfig] = useState(null);

  useEffect(() => {
    api.get("/sdi/config").then((r) => setConfig(r.data)).catch(() => {});
  }, []);

  const send = async () => {
    setLoading(true); setResult(null);
    try {
      const { data } = await api.post("/sdi/playground/send-xml", { xml });
      setResult(data);
      toast.success("XML inviato al SDI");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Errore invio");
      setResult(e?.response?.data);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6 lg:p-10 max-w-5xl" data-testid="sdi-playground">
      <div className="mb-6">
        <div className="text-[10px] uppercase tracking-[0.3em] text-[#1D4ED8] font-bold mb-1">Playground SDI</div>
        <h1 className="font-display font-extrabold text-3xl tracking-tighter">
          Test invio <span className="font-serif-accent text-[#1D4ED8]">diretto</span> OpenAPI
        </h1>
        {config && (
          <div className="mt-3 inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white border border-[#E8E4D9] text-xs font-mono">
            <span className={`w-1.5 h-1.5 rounded-full ${config.mode === "production" ? "bg-red-500" : "bg-amber-500"}`} />
            Modalità: <strong>{config.mode}</strong>
          </div>
        )}
      </div>
      <textarea
        value={xml}
        onChange={(e) => setXml(e.target.value)}
        data-testid="sdi-playground-xml"
        className="w-full h-96 p-4 rounded-2xl border border-[#E8E4D9] bg-white font-mono text-xs focus:border-zinc-900 outline-none"
      />
      <div className="mt-4 flex justify-end">
        <button
          onClick={send} disabled={loading}
          data-testid="sdi-playground-send"
          className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-[#0A0A0A] text-white text-sm font-semibold hover:bg-[#1D4ED8] disabled:opacity-70 transition-colors"
        >
          {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />}
          Invia XML
        </button>
      </div>
      {result && (
        <div className="mt-6 rounded-2xl border border-[#E8E4D9] bg-white p-5">
          <div className="flex items-center gap-2 mb-3">
            <CheckCircle2 className="w-4 h-4 text-emerald-600" />
            <span className="font-semibold text-sm">Risposta SDI</span>
          </div>
          <pre className="bg-zinc-950 text-emerald-300 text-xs p-3 rounded-md overflow-auto max-h-96" data-testid="sdi-playground-result">
            {JSON.stringify(result, null, 2)}
          </pre>
        </div>
      )}
    </div>
  );
}
